export default "__VITE_ASSET__CHTEs068__"